import { createFileRoute } from '@tanstack/react-router'

import { SubscriptionV2NoPossibleStepPage } from '../../components/pages/subscription-v2/subscription-v2-no-possible-step.tsx'

export const Route = createFileRoute('/subscribe-no-possible-step')({
  component: SubscriptionV2NoPossibleStepPage,
})
